import { Text } from '@chakra-ui/react'
import { useMutation } from '@tanstack/react-query'
import { useState } from 'react'
import { useNavigate, useParams } from 'react-router'
import { api } from '~/api/client'
import { useFetchRegistration } from '~/api/hooks'
import { CodeEntry } from '~/components/member/CodeEntry'
import { FlowStepper } from '~/components/member/FlowStepper'
import { MemberLayout } from '~/components/member/layout'
import { Rich, useT } from '~/i18n/use-t'
import { clearDraft, readDraft, saveDraft } from '~/lib/draft'
import { pathForNext } from '~/lib/flow'
import { useStepRegistration } from '~/lib/use-step'

/** S2 Check your email (Step n of N). */
export default function CheckEmail() {
  const { t } = useT()
  const navigate = useNavigate()
  const { providerId = '' } = useParams()
  const step = useStepRegistration('email', 'email', { backTo: `/join/${providerId}/about`, flow: false })
  const refetchRegistration = useFetchRegistration()
  const [resendAt, setResendAt] = useState(() => readDraft().resendAt ?? 0)

  const check = useMutation({ mutationFn: (code: string) => api('registrationCode', { body: { code } }) })
  const resend = useMutation({ mutationFn: () => api('registrationCodeResend') })

  if (!step.ok) return step.gate
  const { reg } = step

  const draftEmail = readDraft().email
  const address = draftEmail ?? reg.emailMasked

  return (
    <MemberLayout backTo={`/join/${providerId}/about`}>
      <FlowStepper step='email' />
      <Text>{address ? <Rich k='email.sentTo' values={{ email: address }} /> : t('email.sentToNoAddress')}</Text>
      <CodeEntry
        resendAt={resendAt}
        onCheck={async (code) => {
          const res = await check.mutateAsync(code)
          clearDraft('resendAt')
          await refetchRegistration()
          navigate(pathForNext(providerId, res.next))
        }}
        onResend={async () => {
          const res = await resend.mutateAsync()
          const at = Date.now() + res.resendAfterSeconds * 1000
          saveDraft({ resendAt: at })
          setResendAt(at)
        }}
        onChangeEmail={() => navigate(`/join/${providerId}/about`)}
      />
    </MemberLayout>
  )
}
